import { action } from 'satcheljs';
export var viewActivity = action('viewActivity');
//# sourceMappingURL=viewActivity.js.map